const setTags = {
	// <title>TOZO Community | TOZO Official</title>
	updateTitle(titleName) {
		document.title =  "TOZO Community | TOZO Official | " + titleName;
	},
	
	// <meta name="description" content="TOZO Community | TOZO Official"/>
	updateMetaDescription(parameter) {
		let content = parameter ? parameter : "TOZO Community | TOZO Official"
		let meta = document.querySelector("meta[name='description']");
	   if (meta) {
	     meta.setAttribute("content", content);
	   } else {
	     meta = document.createElement("meta");
	     meta.setAttribute("name", "description");
	     meta.setAttribute("content", content);
	     document.head.appendChild(meta);
	   }
	},
	
	// <link rel="canonical" href="https://community.tozo.com" />
	updateCanonical(parameter) {
		let httpsUrl = process.env.VUE_APP_API_URL_CanonicalUrl
		let url = parameter ? httpsUrl+parameter : httpsUrl
	   let link = document.querySelector("link[rel='canonical']");
	   if (link) {
	      link.setAttribute("href", url);
	   } else {
	      link = document.createElement("link");
	      link.setAttribute("rel", "canonical");
	      link.setAttribute("href", url);
	      document.head.appendChild(link);
	   }
	}
	
}
export default setTags
